/* ============================================================
   BUKA FORMULA  (/formula/:formulaId)  — Fasa 1, langkah 4 (awal)
   ============================================================
   Menjadikan formula dalam URL sebagai module aktif, kemudian
   membawa pengguna masuk ke workspace.

   ⚠️ SKOP SEMASA: workspace masih DIKONGSI antara semua formula
   (kad produk sama seperti hari ini). "Setiap formula ada kad
   sendiri" ialah kerja seterusnya — ia perlu menapis kad ikut
   `product.moduleId` di dalam WorkspaceView, iaitu halaman
   SEDIA ADA. Jangan buat tanpa kebenaran user.

   ⛔ Gating dikira semula di sini — jangan bergantung pada rak
   sahaja. Pengguna boleh taip URL formula terkunci terus.
   ============================================================ */

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { computeFormulaAccess } from '../config/formulaAccess';

export default function FormulaOpenRoute({
    modules = [],
    isAdmin = false,
    userAllowedModules = [],
    userTier,
    flownityTrialUsed = 0,
    maintenanceLockedModules = [],
    onSetActiveModule,
}) {
    const { formulaId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        /* Senarai module belum sampai (listener Firestore) — tunggu, jangan
           usir pengguna balik ke rak atas sebab yang salah. */
        if (!modules.length) return;

        const mod = modules.find((m) => m.id === formulaId);
        if (!mod) {
            navigate('/formula', { replace: true });
            return;
        }

        const acc = computeFormulaAccess({
            mod, isAdmin, userAllowedModules, userTier,
            flownityTrialUsed, maintenanceLockedModules,
        });

        if (acc.hidden || acc.isLocked) {
            navigate('/formula', { replace: true });
            return;
        }

        onSetActiveModule?.(mod.id);
        navigate('/workspace', { replace: true });
    }, [
        formulaId, modules, isAdmin, userAllowedModules, userTier,
        flownityTrialUsed, maintenanceLockedModules, onSetActiveModule, navigate,
    ]);

    return (
        <div style={{
            height: '100%', display: 'grid', placeItems: 'center',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif', fontSize: 14, color: '#8A8A9C',
        }}>
            Membuka formula…
        </div>
    );
}
